const LOCAL_STORAGE_LOGGED_IN_USER_DATA = "currentUser";
const LOCAL_STORAGE_JWT_TOKEN = "jwtToken";
const API_RESPONSE_MESSAGE_KEY = "message";
const USER_LOGIN_METHOD = "loginMethod"
const LOCAL_STORAGE_ADVANCED_MODE_PREFIX = "advancedMode_";
const LOCAL_STORAGE_ADVANCED_MODE_PROMPT_DISMISSED = "advancedModePromptDismissed_";
// Single key per project for session data: stores { enabled: boolean, sessionId: string | null }
const LOCAL_STORAGE_SESSION_DATA_PREFIX = "sessionData_";

// Helper functions for session data management
const getSessionData = (projectId: string): { enabled: boolean; sessionId: string | null } => {
    const key = `${LOCAL_STORAGE_SESSION_DATA_PREFIX}${projectId}`;
    const stored = localStorage.getItem(key);
    if (stored) {
        try {
            return JSON.parse(stored);
        } catch {
            return { enabled: true, sessionId: null };
        }
    }
    return { enabled: true, sessionId: null };
};

const setSessionData = (projectId: string, data: { enabled: boolean; sessionId: string | null }): void => {
    const key = `${LOCAL_STORAGE_SESSION_DATA_PREFIX}${projectId}`;
    localStorage.setItem(key, JSON.stringify(data));
};

export {
    LOCAL_STORAGE_LOGGED_IN_USER_DATA,
    LOCAL_STORAGE_JWT_TOKEN,
    API_RESPONSE_MESSAGE_KEY,
    USER_LOGIN_METHOD,
    LOCAL_STORAGE_ADVANCED_MODE_PREFIX,
    LOCAL_STORAGE_ADVANCED_MODE_PROMPT_DISMISSED,
    LOCAL_STORAGE_SESSION_DATA_PREFIX,
    getSessionData,
    setSessionData,
}
